(function() {
    let hasScrolled1000px = false;

    const debounce = (func, delay) => {
        let debounceTimer;
        return function() {
            const context = this, args = arguments;
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => func.apply(context, args), delay);
        };
    };

    const canShowPopup = () => {
        const lastShown = localStorage.getItem('newsletterPopupLastShown');
        if (!lastShown) return true;
        const daysSinceLastShown = (Date.now() - lastShown) / (1000 * 60 * 60 * 24);
        return daysSinceLastShown > 90;
    };

    const checkScroll = () => {
        if (window.scrollY < 1000 || hasScrolled1000px || !canShowPopup()) return;
        hasScrolled1000px = true;
        window.removeEventListener('scroll', checkScroll);  // Remove scroll listener
        localStorage.setItem('newsletterPopupLastShown', Date.now().toString()); 
        setTimeout(yourCustomEventFunction, 3000);
    };

    const body = document.querySelector('body');
    const closeBtn = document.querySelector('newsletterform .close-btn-newsletter');

    document.addEventListener("DOMContentLoaded", function() {
        window.addEventListener('scroll', debounce(checkScroll, 50));
    });

    function yourCustomEventFunction() {
        body.classList.add('activeNewsletter');
    }

    if (closeBtn) {
        closeBtn.addEventListener('click', function() {
            body.classList.remove('activeNewsletter');
        });
    }
})();
